import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { Button, Conditional, Text } from '@consumidor-positivo/aurora';

import { UserType } from '../../../../types';
import { SHOffer } from '../../../../services/sortingHat';
import { useOfferRedirect } from '../../../../hooks/useOfferRedirect';
import { RedirectModal } from '../../../../components/RedirectModal';

import { MMTag } from './MMTag';
import { MMHighlights } from './MMHighlights';

import './styles.scss';
import { useMMCard } from './hook';

export type MMcardProps = {
  offer: SHOffer;
  position: number;
  user?: UserType;
};

export const MMCard = ({ offer, position, user }: MMcardProps) => {
  const { cardRef } = useMMCard({ offer, position, user });
  const { handleOfferRedirect, isLoading, isRedirectModalOpen } = useOfferRedirect({ user, location: 'mm-v2' });

  const cardClass = classNames('mm-card', {
    'mm-card--first': position === 0,
    'mm-card--second': position === 1,
    'mm-card--third': position === 2,
  });

  const stampClass = classNames('mm-card__stamp', {
    'mm-card__stamp--first': position === 0,
    'mm-card__stamp--second': position === 1,
    'mm-card__stamp--third': position === 2,
  });

  return (
    <div className={cardClass} ref={cardRef}>
      <Conditional
        condition={position < 3}
        renderIf={
          <div className={stampClass}>
            <Text as="span" variant="heading-micro" weight="bold">
              {position + 1}º
            </Text>
          </div>
        }
      />
      <div className="mm-card__header">
        <img className="mm-card__image" src={offer?.matchMaker?.imageUrl} alt={offer?.matchMaker?.productName} />
        <Text variant="heading-micro" weight="bold">
          {offer?.matchMaker?.productName}
        </Text>
        <MMTag benefit={offer?.matchMaker?.rewardsHighlights} />
        <MMTag chances={offer?.matchMaker?.approvalChance} />
      </div>
      <div className="mm-card__body">
        <MMHighlights offer={offer} position={position} />
      </div>
      <div className="mm-card__footer">
        <Button expand="x" loading={isLoading} onClick={() => handleOfferRedirect({offer})}>
          Pedir Cartão
        </Button>
      </div>
      <Conditional
        condition={isRedirectModalOpen}
        renderIf={
          <>
            {createPortal(
              <RedirectModal
                isOpen={isRedirectModalOpen}
                partnerName={offer?.matchMaker?.partner || ''}
                offerImage={offer?.matchMaker?.imageUrl || ''}
              />,
              document.body
            )}
          </>
        }
      />
    </div>
  );
};
